import { useState } from "react";
import "./Colors/Colors_Tool.css";
import Gradients from "./Colors/Gradients";
import OneColor from "./Colors/OneColor";
import Palettes from "./Colors/Palettes";

const miro = window.miro;

export default function ColorsTools({
  boardSelection,
  userIsPro,
  environment,
}) {
  const [topModeTabSelectState, setTopModeTabSelectState] =
    useState("palettes-mode-tab");

  function handleColorPaletteGradientTab(flag) {
    switch (flag) {
      case "color-mode-tab":
        // as long as we are switching into this mode from another mode
        if (topModeTabSelectState !== "color-mode-tab") {
          setTopModeTabSelectState(flag);
        } else {
        }

        break;
      case "palettes-mode-tab":
        // as long as we are switching into this mode from another mode
        if (topModeTabSelectState !== "palettes-mode-tab") {
          setTopModeTabSelectState(flag);
        } else {
        }
        break;
      case "gradients-mode-tab":
        // as long as we are switching into this mode from another mode
        if (topModeTabSelectState !== "gradients-mode-tab") {
          setTopModeTabSelectState(flag);
        } else {
        }
        break;
    }
  }

  return (
    <div className="grid mt--16">
      <div className="cs1 ce12 mb-8">
        <div className="tabs mt-0">
          <div className="tabs-header-list">
            <div
              tabIndex="1"
              id="palettes-mode-tab"
              className={
                "tab" +
                (topModeTabSelectState === "palettes-mode-tab"
                  ? " tab-active"
                  : "")
              }
              onClick={(e) => handleColorPaletteGradientTab(e.target.id)}>
              <div className="tab-text tab-badge no-click-event">Palettes</div>
            </div>
            <div
              tabIndex="2"
              id="gradients-mode-tab"
              className={
                "tab" +
                (topModeTabSelectState === "gradients-mode-tab"
                  ? " tab-active"
                  : "")
              }
              onClick={(e) => handleColorPaletteGradientTab(e.target.id)}>
              <div className="tab-text tab-badge no-click-event">Gradients</div>
            </div>
            <div
              tabIndex="3"
              id="color-mode-tab"
              className={
                "tab" +
                (topModeTabSelectState === "color-mode-tab"
                  ? " tab-active"
                  : "")
              }
              onClick={(e) => handleColorPaletteGradientTab(e.target.id)}>
              <div className="tab-text tab-badge no-click-event">1 Color</div>
            </div>
          </div>
        </div>
      </div>
      {topModeTabSelectState === "color-mode-tab" ? (
        <OneColor
          boardSelection={boardSelection}
          userIsPro={userIsPro}
          environment={environment}
        />
      ) : topModeTabSelectState === "palettes-mode-tab" ? (
        <Palettes
          boardSelection={boardSelection}
          userIsPro={userIsPro}
          environment={environment}
        />
      ) : topModeTabSelectState === "gradients-mode-tab" ? (
        <Gradients
          boardSelection={boardSelection}
          userIsPro={userIsPro}
          environment={environment}
        />
      ) : null}
    </div>
  );
}

// {
//   savedGradients.map((savedGradient, index) => {
//     return (
//       <div key={index} className="cs1 ce12 grid">
//         <div
//           className="cs1 ce4 gradient-strip"
//           style={{ background: savedGradient.gradient }}></div>
//         <div className="cs5 ce12">
//           {savedGradient.name} {savedGradient.color}
//         </div>
//       </div>
//     );
//   });
// }
